import { getSecureLocalItem } from "utils/secureSessionStorage";
import api from "./api";

const getAuthConfig = async () => {
  const token = getSecureLocalItem("token");
  return {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };
};

// Super Admin Login
export const superAdminLogin = async (credentials) => {
  return api.post("/v1/api/super-admin/login", credentials);
};

// Regular User/Tenant Login
export const regularUserLogin = async (credentials) => {
  return api.post("/v1/api/login", credentials);
};

// Registration , here no need token
export const register = async (userData) => {
  return api.post("v1/api/auth/register", userData);
};
